/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import SimpleInput from '../../forms/simpleInput';
import { currency } from '/client/src/constants';
import { format } from '/client/src/utils/amountTransformation';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import './ticket.scss';

type DiscountItemPropsType = {
  eventDetail: {
    default_currency: string
  },
  data: {
    sale_end_time_utc: string,
    description: string,
    goal: number,
    id: string,
    name: string,
    prefilled_amount?: any,
    amount?: number
  },
  onHandleChangeDonation: () => void,
  onHandleSetDonatedTotal: () => void
};

const TicketDonation = (props: DiscountItemPropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const donationList = [
    1000,
    2000,
    5000,
    10000
  ];
  const [donationAmount, setDonationAmount] = React.useState(_.get(props.data, 'prefilled_amount', 0));
  const [isShowFullInfo, setShowFullInfo] = React.useState(false);
  const selectedAttr = 'is-donat';

  const setDonat = (count: number, target: any) => {
    const current = document.querySelector(`#donationFor${props.data.id} [${selectedAttr}]`);

    props.onHandleChangeDonation(props.data, count);
    if (!!current) current.removeAttribute(selectedAttr);
    target.setAttribute(selectedAttr, '');
  };

  const inputSetDonat = (e: any) => {
    const _value = e.target.value.split(currency[`${context.profileCurrent.currency}`])[1] * 100 || 0;

    setDonationAmount(_value);
    setDonat(_value, e.target);
  };

  React.useEffect((): void =>  props.onHandleSetDonatedTotal(+props.data.amount || 0), [props.data.amount]);

  return (
    <div className={'sparxo-checkout-Ticket_wrapper'}>
      <div className={'sparxo-checkout-Ticket_wrapperBefore'} />
      <div className={`sparxo-checkout-Ticket_ticket ${isShowFullInfo ? 'sparxo-checkout-Ticket_ticketFullSize' : ''}`}>
        <div className={'sparxo-checkout-Ticket_info'}>
          {/* header*/}
          <div className={'sparxo-checkout-Ticket_donationHeader'}>
            <span className={'sparxo-checkout-Ticket_title'}>Donation</span>
            <div className={'sparxo-checkout-Ticket_donationHeaderProgress'}>
              <div className={'sparxo-checkout-Ticket_donationHeaderProgressText'}>
                <span>{format(currency[`${context.profileCurrent.currency}`], +props.data.amount || 0)} riased</span>
                <span>{format(currency[`${context.profileCurrent.currency}`], +props.data.goal)} goal</span>
              </div>
              <div className={'sparxo-checkout-Ticket_progress'}>
                <div
                  className={'sparxo-checkout-Ticket_progressBar'}
                  style={{
                    width: `${(props.data.amount || 0) / props.data.goal * 100}%`
                  }}
                />
              </div>
            </div>
          </div>
          <div className={'sparxo-checkout-Ticket_description'}>
            <div className={'sparxo-checkout-Ticket_donationTitle'}><b>{props.data.name}</b></div>
            <div className={!isShowFullInfo ? 'sparxo-checkout-Ticket_isShowShortDonatInfo' : ''}>
              {props.data.description}
            </div>
            <div
              className={
              `sparxo-checkout-Ticket_moreInfo ${!isShowFullInfo ? 'sparxo-checkout-Ticket_moreInfoLess' : ''}`
              }
              onClick={(): void => setShowFullInfo(!isShowFullInfo)}
            >
              {!isShowFullInfo ? 'more' : 'less'} ticket info
            </div>
          </div>
        </div>

          <div className={'sparxo-checkout-Ticket_gridContainer'} id={`donationFor${props.data.id}`}>
             {_.map(donationList, (item: number, index: number): void => (
              <button
                key={`sparxo-ticketDonation-btn${index}`}
                className={'sparxo-checkout-Ticket_donationBtn'}
                type='button'
                onClick={(e: any): void => setDonat(item, e.target)}
              >{format(currency[`${context.profileCurrent.currency}`], item)}</button>
             ))}
            <div className={'sparxo-checkout-Ticket_gridInput'}>
              <SimpleInput
                classes={{ input: 'sparxo-checkout-Ticket_donationInput' }}
                type='text'
                id={`donation-${_.random(0, 9999)}`}
                name='donation'
                placeholder="$ Other"
                value={format(currency[`${context.profileCurrent.currency}`], +donationAmount)}
                onFocus={(e: any): void => inputSetDonat(e)}
                onChange={(e: any): void => inputSetDonat(e)}
              />
            </div>
          </div>
      </div>
      <div className={'sparxo-checkout-Ticket_wrapperAfter'} />
    </div>
  );
};

export default TicketDonation;
